import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import './Contact.css';

const PLANS = ['Basic – $600/mo', 'Pro – $900/mo', 'Premium – $1,500/mo', 'Enterprise – Custom', 'Not sure yet'];

export default function Contact() {
  const [searchParams] = useSearchParams();
  const defaultPlan = (() => {
    const p = searchParams.get('plan') || '';
    return PLANS.find(x => x.toLowerCase().startsWith(p.toLowerCase())) || '';
  })();

  const [form, setForm] = useState({ name:'', email:'', company:'', phone:'', plan: defaultPlan, message:'' });
  const [status, setStatus] = useState('');

  const submit = async e => {
    e.preventDefault();
    setStatus('sending');
    try {
      await axios.post('/api/leads', form);
      setStatus('success');
      setForm({ name:'', email:'', company:'', phone:'', plan: '', message:'' });
    } catch { setStatus('error'); }
  };

  return (
    <main className="contact-page">
      <div className="contact-hero">
        <div className="container">
          <p className="section-label">Get In Touch</p>
          <h1>Request a Demo</h1>
          <p>See how Route Rover can transform your delivery operations. Our team will contact you within 24 hours.</p>
        </div>
      </div>

      <div className="container contact-body">
        <form className="contact-form" onSubmit={submit}>
          <div className="form-row">
            <div className="form-group">
              <label>Full Name *</label>
              <input type="text" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} required placeholder="Ahmed Hassan" />
            </div>
            <div className="form-group">
              <label>Work Email *</label>
              <input type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} required placeholder="ahmed@company.com" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Company</label>
              <input type="text" value={form.company} onChange={e=>setForm({...form,company:e.target.value})} placeholder="Your Company" />
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input type="tel" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} placeholder="+20 100 000 0000" />
            </div>
          </div>
          <div className="form-group">
            <label>Interested Plan</label>
            <select value={form.plan} onChange={e=>setForm({...form,plan:e.target.value})}>
              <option value="">— Select a plan —</option>
              {PLANS.map(p => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea rows={5} value={form.message} onChange={e=>setForm({...form,message:e.target.value})} placeholder="Tell us about your delivery operations..." />
          </div>
          <button type="submit" className="submit-btn" disabled={status==='sending'}>
            {status === 'sending' ? 'Sending...' : 'Send Request'}
          </button>
          {status === 'success' && <p className="form-success">✅ Request sent! We'll contact you soon.</p>}
          {status === 'error'   && <p className="form-error">❌ Something went wrong. Please try again.</p>}
        </form>

        <div className="contact-info">
          <h3>Why Route Rover?</h3>
          {[['40%','Faster Deliveries'],['30%','Cost Reduction'],['99.9%','Automation Rate'],['50%','Fleet Productivity']].map(([v,l])=>(
            <div className="contact-stat" key={l}>
              <strong>{v}</strong><span>{l}</span>
            </div>
          ))}
          <div className="contact-details">
            <p>📧 info@routerover.tech</p>
            <p>📞 +201200012327</p>
            <p>📍 Cairo, Egypt</p>
          </div>
        </div>
      </div>
    </main>
  );
}
